import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { authFeatureKey, authReducer } from './auth.reducer';
import { AuthEffects } from './auth.effects';

export const AuthFeatureProviders = [
  provideState(authFeatureKey, authReducer),
  provideEffects(AuthEffects),
];
